<template>
  <div class="lawdettli">
    <sub-title text="刑法条例" />
    <ul class="hdlist">
      <li class="hditem ellipsis" v-for="item in 5" :key="item">
        财政部、国家税务总局关于延续实续实
      </li>
    </ul>
    <div class="viewall">查看更多</div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.lawdettli {
  padding: 22px 12px;
  .hdlist {
    font-size: 16px;
    padding-left: 14px;
    padding-bottom: 24px;
    .hditem {
      margin-top: 24px;
      color: #333333;
      cursor: pointer;
      position: relative;
      padding-left: 10px;
      &::before {
        content: "";
        width: 4px;
        height: 4px;
        background: #666666;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
      }
      &:hover {
        color: #0465ea;
      }
    }
  }
  .viewall {
    cursor: pointer;
    width: 194px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin: 0 auto;
    background: #f1f7ff;
    border-radius: 5px;
    font-size: 18px;
    color: #0465ea;
  }
}
</style>